import React, { ReactNode } from 'react';
import { IControlProps, IPartialFormGroup } from '../types';
import FormControl from '../FormControl';
import Textarea, { ITextareaProps } from '../../atoms/Textarea';
import { useHookFormController } from '../../hooks/useHookFormController';

export type ITextareaControlProps = ITextareaProps &
    IControlProps & {
        formGroupProps?: IPartialFormGroup;
        label?: ReactNode;
        tooltip?: ReactNode;
        required?: boolean;
        aiAutocompleteKey?: string;
        /** Обрезать пробелы по краям на blur. false — для значений, где пробелы значимы (SQL, скрипты, шаблоны) */
        trimOnBlur?: boolean;
    };

const TextareaControl = ({
    name,
    rules,
    defaultValue,
    control,
    shouldUnregister,
    label,
    tooltip,
    required,
    formGroupProps,
    hideErrorMessage,
    trimOnBlur = true,
    onBlur,
    ...props
}: ITextareaControlProps) => {
    const Controller = useHookFormController();

    return (
        <Controller
            control={control}
            name={name}
            rules={rules}
            shouldUnregister={shouldUnregister}
            defaultValue={defaultValue}
            render={({ field: { onChange, onBlur: rhfOnBlur, value, ...restFieldProps } }) => (
                <FormControl
                    readonlyAppearance={props.readOnly || props.disabled ? 'field' : undefined}
                    name={name}
                    label={label}
                    tooltip={tooltip}
                    required={required}
                    control={control}
                    hideErrorMessage={hideErrorMessage}
                    {...formGroupProps}
                >
                    <Textarea
                        {...restFieldProps}
                        {...props}
                        // undefined из данных формы — пустое управляемое поле (см. InputControl)
                        value={value ?? ''}
                        onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => {
                            onChange(e);
                        }}
                        onBlur={(e: React.FocusEvent<HTMLTextAreaElement>) => {
                            if (trimOnBlur && !props.readOnly && !props.disabled && typeof value === 'string') {
                                const trimmed = value.trim();
                                if (trimmed !== value) {
                                    onChange(trimmed);
                                }
                            }
                            rhfOnBlur();
                            onBlur?.(e);
                        }}
                    />
                </FormControl>
            )}
        />
    );
};

export default TextareaControl;
